var SiteService = function() {
  this.addSponsorClass = function(){
    EF.program.fetch().done(function () {
      _.each(EF.program.get('sponsorships'), function (sponsor) {
        $('body').addClass(sponsor.slug);
      });
    });
  };
};

module.exports = new SiteService();